import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import TabsSwitcher from '@widgets/modal-delivery/ui/TabsSwitcher'

import { Product } from '@shared/generated'
import { cn } from '@shared/lib/cn'
import RatingPreview from '@shared/ui/rating/preview/preview'
import getNoun from '@shared/uttils/getNoun'

import About from './About'

import styles from './ProductTabs.module.scss'

export default function ProductTabs ({ product }: { product: Product }) {
  const { t: tp } = useTranslation('product')
  const [ activeTab, setActiveTab ] = useState('about_product')

  const isTablet = useMediaQuery('(max-width: 991px)')

  const tabs = [
    { label: tp('product.about'), value: 'about_product' },
    {
      label: (
        <>
          {tp('product.reviews')}
          { !isTablet && <span className={styles['tab-rating']}>
            <RatingPreview
              className={styles['root__rating-star']}
              classNameText={styles['root__rating-value']}
              value={product.average_rating as number}
            />
            <span className={styles['root__rating-count']}>
              {product.review_count}{' '}
              {getNoun(
                product.review_count as number,
                tp('productReview.1'),
                tp('productReview.2'),
                tp('productReview.3'),
              )}
            </span>
          </span>
          }
        </>
      ),
      value: 'reviews',
    },
  ]

  return (
    <>
      <TabsSwitcher
        className={styles['switcher']}
        tabs={tabs}
        active={activeTab}
        onChange={setActiveTab}
        cols={2}
      />

      {activeTab === 'about_product' && <div className={styles.tabContent}><About product={product} /></div>}

      {activeTab === 'reviews' && (
        <div className={cn(styles.tabContent, styles.tabContent__comingSoon)}>
          <p>{tp('product.reviewsComingSoon')}</p>
        </div>
      )}
    </>
  )
}